var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIncomingMail = function SvgIncomingMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "B111D90D-F23F-4912-872C-60EB5537B719@svg")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Event-banners",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Newsletter-widget-web",
    transform: "translate(-258.000000, -1302.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Communication-/-Incoming-mail",
    transform: "translate(258.400000, 1302.400000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    x: 0,
    y: 0,
    width: 31.2,
    height: 31.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7,11.7 C26.1359403,11.7 27.3,12.8640597 27.3,14.3 L27.3,26 C27.3,27.4359403 26.1359403,28.6 24.7,28.6 L6.5,28.6 C5.06405965,28.6 3.9,27.4359403 3.9,26 L3.9,14.3 C3.9,12.8640597 5.06405965,11.7 6.5,11.7 L24.7,11.7 Z M24.9084593,14.4877527 C24.6531672,14.0136387 24.0618667,13.8362485 23.5877527,14.0915407 L23.5877527,14.0915407 L15.6,18.3926383 L7.61224733,14.0915407 C7.13813334,13.8362485 6.54683283,14.0136387 6.29154068,14.4877527 C6.03624853,14.9618667 6.21363868,15.5531672 6.68775267,15.8084593 L6.68775267,15.8084593 L15.1377527,20.3584593 C15.4263296,20.5138469 15.7736704,20.5138469 16.0622473,20.3584593 L16.0622473,20.3584593 L24.5122473,15.8084593 C24.9863613,15.5531672 25.1637515,14.9618667 24.9084593,14.4877527 Z",
    id: "Combined-Shape",
    fill: "#212529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0185424,1.29799099 L14.0185424,3.84140654 L14.0185424,3.84140654 L11.4085697,3.84140654 C11.0495846,3.84140654 10.7585697,4.13242145 10.7585697,4.49140654 L10.7585697,5.82169485 C10.7585697,6.18067994 11.0495846,6.47169485 11.4085697,6.47169485 L14.0185424,6.47169485 L14.0185424,6.47169485 L14.0185424,9.0151104 C14.0185424,9.37409549 14.3095573,9.6651104 14.6685424,9.6651104 C14.8223475,9.6651104 14.9711697,9.61057049 15.0885528,9.51118627 L19.6459123,5.65262656 C19.9198874,5.42066123 19.9539431,5.01051544 19.7219777,4.7365403 C19.6987678,4.70912699 19.6733256,4.68368473 19.6459123,4.66047483 L15.0885528,0.801915125 C14.8145777,0.569949788 14.4044319,0.604005459 14.1724665,0.877980596 C14.0730823,0.995363681 14.0185424,1.14418588 14.0185424,1.29799099 Z",
    id: "Shape",
    fill: "#6C757D",
    transform: "translate(15.495200, 5.156551) rotate(-270.000000) translate(-15.495200, -5.156551) "
  }))))));
};
export default SvgIncomingMail;